export default __webpack_public_path__ + "static/media/warning--roundabout--g3.596a7a10.png";